const headerMainContainer = document.getElementById('header-main-container');
const menuMobileContainer = document.getElementById('nav-mobile-header');
const iconOpenCloseMenu = document.getElementById('icon-open-close-menu');
const mainContent = document.getElementById("MainContent")

let lastScrollTop = window.pageYOffset || document.documentElement.scrollTop;

addEventListener("scroll", (event) => {
  switch(headerMainContainer?.dataset.stickyType){
      case "on-scroll-up":
        let currentScrollTop = window.pageYOffset || document.documentElement.scrollTop;
        
        if (currentScrollTop < lastScrollTop) {
          headerMainContainer.parentNode.classList.add("event-sticky-header");
          if(window.innerWidth > 768){
            mainContent.style.paddingTop= "62px";  
          }
          
        }else{
          headerMainContainer.parentNode.classList.remove("event-sticky-header");
          if(window.innerWidth > 768){
            mainContent.style.paddingTop= "0px";
          }
          
        }

        lastScrollTop = currentScrollTop <= 0 ? 0 : currentScrollTop; // Evitar valores negativos
        break;
  }
});

